import React from "react";
import { useField } from "formik";
import FieldFeedback, { useFieldFeedback } from "./FieldFeedback";

const AACheckbox = ({ children, label, hint, value, ...props }) => {
  const [field, meta] = useField({ ...props, type: "checkbox" });
  const feedback = useFieldFeedback(props, meta.error, hint);

  return (
    <li className="custom_boolean" data-signal-field="" data-signal-label={typeof label === "string" ? label : undefined} data-signal-name={props.name}>
      <label>
        <input type="checkbox" {...field} {...props} {...feedback}/>
        {label ? label : null}
        {children}
      </label>
      <FieldFeedback id={feedback.id} error={meta.error} hint={hint} />
    </li>
  );
};

export default AACheckbox;
